import { getLoggedInUser } from 'utilities/helpers';

const useDrumAccess = () => {
  const { user } = getLoggedInUser();
  const level = user?.level ?? 1;
  return {
    canAct: level >= 2,
    canReactivate: level >= 2
  };
};

export default useDrumAccess;
